import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, onBeforeUnmount } from 'vue';
import ExpenseEdit from '@/modules/expenses/ExpenseEdit.vue';
export default {
  __name: 'ExpenseEditModal',
  props: {
    state: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: false,
      default: () => ({})
    },
    leanLawApi: {
      type: Object,
      required: false
    },
    userService: {
      type: Object,
      required: false
    },
    alerts: {
      type: Object,
      required: false
    },
    tracking: {
      type: Object,
      required: false
    },
    method: {
      type: String,
      default: 'Invoice Page'
    }
  },
  setup(__props) {
    // ExpenseEdit is a bare v-card, so a route that mounts it on its own renders it
    // inline in the page rather than over it. Every other caller wraps it in a
    // v-dialog (see ExpenseLists.vue and MatterSettlement.vue) - this is that
    // wrapper for the routes that open it, in the same spirit as timeEntryModal.vue
    // around EditEntry.vue.
    // When we kill step-by-step, we can delete this file. ts-enforce-ignore
    const props = __props;

    // The route mounting this component is what makes it open.
    const dialogOpen = ref(true);
    let closing = false;

    // ExpenseEdit's own Cancel and Save navigate to the parent state, which unmounts
    // us. Escape and a backdrop click only close the dialog though, and leaving the
    // route on the child state means the next click on an expense can't resolve it -
    // so follow the dialog back to the parent.
    const onToggle = open => {
      if (open || closing) return;
      closing = true;
      props.state.go('^');
    };
    onBeforeUnmount(() => {
      closing = true;
    });
    return (_ctx, _cache) => {
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_dialog, {
        modelValue: dialogOpen.value,
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => dialogOpen.value = $event), onToggle],
        width: "700"
      }, {
        default: _withCtx(() => [_createVNode(ExpenseEdit, {
          stateParams: __props.stateParams,
          state: __props.state,
          leanLawApi: __props.leanLawApi,
          userService: __props.userService,
          alerts: __props.alerts,
          tracking: __props.tracking,
          method: __props.method
        }, null, 8, ["stateParams", "state", "leanLawApi", "userService", "alerts", "tracking", "method"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};